import gql from 'graphql-tag';

const DriverAssignment = gql(/* GraphQL */ `
  query DriverAssignment($id: ID!) {
    driverAssignment: dmDriverAssignment(id: $id) {
      id
      deliveryStatus
      delivery {
        id
        orderNumber
        eventAt
        deliverySetup
        distanceInMiles
        durationInMinutes
        driverAskFor
        pickupAddress {
          id
          instructions
          locationName
          street1
          street2
          city
          state
          zip
        }
        dropoffAddress {
          id
          locationName
          street1
          street2
          city
          state
          zip
          phone
          instructions
          timeZoneIdentifier
        }
        dropoffWindow {
          endAt
          startAt
        }
        order {
          orderItems {
            name
            quantity
          }
        }
      }
    }
  }
`);

export default DriverAssignment;
